/* global tinymce */

function escapeAttrValue(value) {
  return String(value).replace(/"/g, '&quot;');
}

function insertIntoEditor(shortcode) {
  if (window.tinymce && tinymce.activeEditor && !tinymce.activeEditor.isHidden()) {
    tinymce.activeEditor.execCommand('mceInsertContent', false, shortcode);
    return;
  }

  const textarea = document.getElementById('content');
  if (!textarea) return;

  const start = textarea.selectionStart || 0;
  const end = textarea.selectionEnd || 0;

  textarea.value = textarea.value.substring(0, start) + shortcode + textarea.value.substring(end);
  textarea.focus();
  textarea.selectionStart = textarea.selectionEnd = start + shortcode.length;
}

/**
 * Initialize the Classic Editor metabox integration.
 * Call this once (from your main admin entry) after DOM is ready.
 *
 * Expects metabox markup containing:
 * - #smartcontentsync-smart-content-metabox
 * - [data-smart-content-sync-smart-content-id="1"] (input/select)
 * - [data-smart-content-sync-insert="1"] (button)
 * - optionally [data-smart-content-sync-open-modal="1"] (button)
 */
export function initSmartContentSyncClassicEditorMetabox() {
  const metabox = document.getElementById('smartcontentsync-smart-content-metabox');
  if (!metabox) return;

  const insertBtn = metabox.querySelector('[data-smart-content-sync-insert="1"]');
  const openModalBtn = metabox.querySelector('[data-smart-content-sync-open-modal="1"]');

  if (openModalBtn && window.smartContentSyncClassicEditorOpenSmartContentModal) {
    openModalBtn.addEventListener('click', () =>
      window.smartContentSyncClassicEditorOpenSmartContentModal()
    );
  }

  if (!insertBtn) return;

  insertBtn.addEventListener('click', () => {
    const idInput = metabox.querySelector('[data-smart-content-sync-smart-content-id="1"]');
    const id = idInput ? String(idInput.value || '').trim() : '';
    if (!id) return;

    // NOTE: Adjust 'id' if your shortcode uses a different attribute name.
    insertIntoEditor(`[smart_content id="${escapeAttrValue(id)}"]`);
  });
}
